import user from './user';
import order from './order';
import hotel from './hotel';

/* 接口汇总 */
export default {
    // 用户相关接口
    user: user,
    // 订单相关接口
    order: order,
    // 酒店相关接口
    hotel: hotel
}


// WEBPACK FOOTER //
// ./src/api/apis.js